import { render, staticRenderFns } from "./DetailShipper.vue?vue&type=template&id=a2acf76a"
import script from "./DetailShipper.vue?vue&type=script&lang=js"
export * from "./DetailShipper.vue?vue&type=script&lang=js"
import style0 from "./DetailShipper.vue?vue&type=style&index=0&id=a2acf76a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports